import {  Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserLogin } from '../../interfaces/user-login';
import { RequestService } from 'app/shared/services/request.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})

export class LoginComponent implements OnInit {



  public loginForm: FormGroup = this.formBuilder.group({
      email: ["", [Validators.email,Validators.required]],
      password: ["", [Validators.required]]
  })
  public loading: boolean = false;

  public error: Boolean = false;

  constructor(
  private readonly requestService: RequestService,
    private formBuilder:FormBuilder,
    private authService: AuthService,
    private route: Router) {
  }

  ngOnInit(): void {
  }
  get email (){
    return this.loginForm.get('email');
  }
  get password(){
    return this.loginForm.get('password');
  }

  login(event: Event): void {
    this.loading = true;
    event.preventDefault();
    this.error = false
    const loginRequest: UserLogin = {
      email: this.loginForm.controls['email'].value,
      password: this.loginForm.controls['password'].value,
    }
    this.authService.loginUser(loginRequest).subscribe({

      next: (resp) => {
        console.log(resp);
        this.error = false
        this.route.navigate(['/dashboard']);
      },
      error: (error) => {
        this.error = true
      }
    }) ;

  }

  resetPwd() { }
}
